import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './components/app/app.component';
import {LoginComponent} from "./components/auth/login/login.component";
import {RoutingModule} from "./routing.module";
import {FormsModule} from "@angular/forms";
import {AuthGuard, AuthService, AuthTokenStore} from "./services/auth.service";
import {HomeComponent} from './components/home/home.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from './http/auth.interceptor';
import {BaseUrlInterceptor} from './http/baseurl.interceptor';
import {BugfixWA18396Interceptor} from './http/bugfix.interceptor';
import {ReservationsListComponent} from './components/home/reservations-list/reservations-list.component';
import {ReservationsService} from './services/reservations.service';
import {MenuSetsListComponent} from './components/home/menu-sets-list/menu-sets-list.component';
import {MenuSetsService} from './services/menu-sets.service';
import {CalendarComponent} from "./components/home/calendar/calendar.component";
import {CalendarModule} from 'ap-angular2-fullcalendar';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {ProfileService} from "./services/profile.service";
import {LineBreakPipe} from "./pipes/line-break.pipe";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmReservationModalComponent} from './components/home/reservations-list/modals/confirm-reservation-modal.component';
import {NotificationsService} from "./services/notifications.service";
import {RejectReservationModalComponent} from "./components/home/reservations-list/modals/reject-reservation-modal.component";
import {MenuSetDetailsComponent} from './components/home/menu-set-details/menu-set-details.component';
import {QuillModule} from 'ngx-quill'
import {DisposalsService} from './services/disposals.service';
import {ReservationEventModalComponent} from './components/home/calendar/modals/reservation-event-modal.component';
import {CreateDisposalModalComponent} from './components/home/calendar/modals/create-disposal-modal.component';
import {EventsService} from "./services/events.service";
import {RemoveDisposalModalComponent} from "./components/home/calendar/modals/remove-disposal-modal.component";
import {ReservationDetailsComponent} from "./components/home/reservation-details/reservation-details.component";
import {ConfirmContactModalComponent} from "./components/home/reservations-list/modals/confirm-contact-modal.component";
import {PasswordResetRequestComponent} from "./components/auth/password-reset-request/password-reset-request.component";
import {PasswordResetConfirmComponent} from "./components/auth/password-reset-confirm/password-reset-confirm.component";
import {ReservationSummaryModalComponent} from "./components/home/reservation-summary-modal/reservation-summary-modal.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PasswordResetRequestComponent,
    PasswordResetConfirmComponent,
    HomeComponent,
    ReservationsListComponent,
    ReservationDetailsComponent,
    MenuSetsListComponent,
    CalendarComponent,
    LineBreakPipe,
    ConfirmReservationModalComponent,
    RejectReservationModalComponent,
    MenuSetDetailsComponent,
    ReservationEventModalComponent,
    CreateDisposalModalComponent,
    RemoveDisposalModalComponent,
    ConfirmContactModalComponent,
    ReservationSummaryModalComponent,
  ],
  imports: [
    NgbModule.forRoot(),
    FormsModule,
    BrowserModule,
    RoutingModule,
    HttpClientModule,
    CalendarModule,
    LoadingBarHttpClientModule,
    QuillModule,
  ],
  providers: [
    AuthService,
    AuthGuard,
    AuthTokenStore,
    ReservationsService,
    MenuSetsService,
    ProfileService,
    NotificationsService,
    DisposalsService,
    EventsService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: BugfixWA18396Interceptor, multi: true},
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmReservationModalComponent,
    RejectReservationModalComponent,
    ReservationEventModalComponent,
    CreateDisposalModalComponent,
    RemoveDisposalModalComponent,
    ConfirmContactModalComponent,
    ReservationSummaryModalComponent,
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/app.module.ts